import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const CourseTag = ({ children, className, style }) => {
  const classes = classNames(
    "text-xs bg-bestseller p-1 px-2 text-gray-800 font-medium tags leading-snug",
    className
  );

  return (
    <span className={classes} {...{ style }}>
      {children}
    </span>
  );
};

CourseTag.propTypes = {
  children: PropTypes.element.isRequired,
};

export default CourseTag;
